// src/views/comunicados/ComunicadosList.jsx
import React, { useState, useEffect, useCallback } from "react";
import comunicadosService  from "../../services/comunicadosService";
import condominosService   from "../../services/condominosService";
import condominiosService from "../../services/condominiosService";
import { useAuth } from "../../contexts/AuthContext";
import DeleteModal from "../../components/ui/DeleteModal";
import useSocket from "../../hooks/useSocket";
import AnexosUpload from "../../components/ui/AnexosUpload";
import unidadesService from "../../services/unidadesService";
import Banner from "../../components/ui/Banner";
import ConfirmModal from "../../components/ui/ConfirmModal";

const fmtDt = dt => { if(!dt) return "—"; try{ return new Date(dt).toLocaleString("pt-BR"); }catch{return dt;} };

const CATEGORIA_ICON = {
  Aviso:"bi-megaphone-fill", Assembleia:"bi-people-fill",
  Manutencao:"bi-tools", Financeiro:"bi-cash-coin",
  Seguranca:"bi-shield-fill", Obras:"bi-building-fill",
  Lazer:"bi-balloon-fill", Outro:"bi-bell-fill",
};
const CATEGORIA_COLOR = {
  Aviso:"#3B82F6", Assembleia:"#8B5CF6", Manutencao:"#F59E0B",
  Financeiro:"#10B981", Seguranca:"#EF4444", Obras:"#F97316",
  Lazer:"#EC4899", Outro:"#6B7280",
};
const PRIORIDADE_STYLE = {
  Normal:     {background:"var(--bg-page)",color:"var(--gray-600)"},
  Importante: {background:"#FFF7ED",color:"#C2410C"},
  Urgente:    {background:"var(--bg-danger-soft)",color:"#991B1B"},
};
const DEST_LABEL = {
  Todos:"Todos", PorBloco:"Por Bloco", PorUnidade:"Por Unidade",
  Proprietarios:"Proprietários", Inquilinos:"Inquilinos",
};

const EMPTY = {
  titulo:"", conteudo:"", categoria:"Aviso", prioridade:"Normal",
  destinatario:"Todos", blocoDestino:"", idUnidadeDestino:"", idCondomino:"",
  dtExpiracao:"", criadoPor:"Administrador",
};

export default function ComunicadosList() {
  const { condominioAtivo, isAdmin, isGerente } = useAuth();
  const { podeEditar } = useAuth();
  const canEdit = podeEditar("comunicados");
  const [condominios, setCondominios]   = useState([]);

  // Sync with navbar condominioAtivo — updates whenever user changes it
  useEffect(() => {
    if (condominioAtivo?.id) setIdCondo(String(condominioAtivo.id));
    else setIdCondo("");
  }, [condominioAtivo]);
  const [idCondo, setIdCondo]           = useState("");
  const [data, setData]                 = useState([]);
  const [unidades,  setUnidades]  = useState([]);
  const [condominos, setCondominos] = useState([]);
  const [loading, setLoading]           = useState(false);
  const [pagination, setPagination]     = useState({total:0,totalPages:1});
  const [filtros, setFiltros]           = useState({categoria:"",ativo:"",page:1});
  // Novo push badge
  const [novos, setNovos]               = useState([]);
  // Modal
  const [showModal, setShowModal]       = useState(false);
  const [editData, setEditData]         = useState(null);
  const [form, setForm]                 = useState(EMPTY);
  const [errors, setErrors]             = useState({});
  const [saving, setSaving]             = useState(false);
  const [anexosForm, setAnexosForm]     = useState([]); // anexos temporários no modal
  // Delete
  const [showDelete, setShowDelete]     = useState(false);
  const [deleteTarget, setDeleteTarget] = useState(null);
  const [deleting, setDeleting]         = useState(false);
  // Detalhe
  const [selected, setSelected]         = useState(null);
  const [estatisticas, setEstatisticas] = useState(null);
  const [reenviando, setReenviando]     = useState(false);

  // Feedback / confirmação
  const [banner, setBanner] = useState(null);
  const showBanner = (tipo, msg) => { setBanner({ tipo, msg }); setTimeout(()=>setBanner(null), 7000); };
  const [confirmReenvio, setConfirmReenvio] = useState(null);

  // WebSocket — recebe novo comunicado em tempo real
  useSocket(idCondo, {
    novo_comunicado: (payload) => {
      setNovos(prev => [payload, ...prev]);
      carregar();
    }
  });

  useEffect(() => {
    condominiosService.listar({limit:100}).then(r=>{
      setCondominios(r.data);

    }).catch(()=>{});
  },[]);

  useEffect(()=>{
    if(!idCondo) return;
    unidadesService.listar({idCondominio:idCondo, limit:500}).then(r=>setUnidades(r.data||[])).catch(()=>{});
    condominosService.listarSelect(idCondo).then(r=>setCondominos(r.data||[])).catch(()=>{});
  },[idCondo]);

  const carregar = useCallback(async () => {
    if(!idCondo) return;
    setLoading(true);
    try {
      const r = await comunicadosService.listar({idCondominio:idCondo,...filtros,limit:20});
      setData(r.data); setPagination(r.pagination);
    } catch(e){console.error(e);}
    finally{setLoading(false);}
  },[idCondo, filtros]);

  useEffect(()=>{ carregar(); },[carregar]);

  const setF = (f,v) => setFiltros(p=>({...p,[f]:v,page:1}));
  const setFm = (f,v) => { setForm(p=>({...p,[f]:v})); setErrors(p=>({...p,[f]:undefined})); };

  const abrirModal = async (item=null) => {
    setEditData(item);
    setForm(item ? {...EMPTY,...item} : {...EMPTY});
    setErrors({});
    setAnexosForm([]);
    setShowModal(true);
    // Em edição, carrega anexos já salvos para exibir/permitir remoção
    if (item?.id) {
      try {
        const r = await comunicadosService.listarAnexos(item.id);
        if (Array.isArray(r?.data)) setAnexosForm(r.data);
      } catch { /* silencioso */ }
    }
  };

  const validate = () => {
    const e={};
    if(!form.titulo.trim())   e.titulo="Título obrigatório";
    if(!form.conteudo.trim()) e.conteudo="Conteúdo obrigatório";
    // Expiração: se preenchida, precisa estar no futuro (evita comunicado nascer expirado).
    if (form.dtExpiracao && form.dtExpiracao.trim() !== "") {
      const exp = new Date(form.dtExpiracao);
      const agora = new Date();
      if (isNaN(exp.getTime())) {
        e.dtExpiracao = "Data inválida.";
      } else if (exp <= agora) {
        e.dtExpiracao = "A data de expiração deve ser futura (ou deixe em branco).";
      }
    }
    setErrors(e); return Object.keys(e).length===0;
  };

  const handleSave = async () => {
    if(!validate()) return;
    setSaving(true);
    try {
      const payload = {...form, idCondominio:idCondo};
      let idComunicado = editData?.id;
      if(editData?.id) await comunicadosService.atualizar(editData.id, payload);
      else {
        const r = await comunicadosService.criar(payload);
        idComunicado = r.data?.id;
      }
      // Upload anexos novos (os que não têm id ainda)
      if (idComunicado) {
        for (const a of anexosForm.filter(x=>!x.id)) {
          await comunicadosService.uploadAnexo(idComunicado, a).catch(()=>{});
        }
      }
      setShowModal(false); setAnexosForm([]);
      showBanner("success", editData?.id ? "Comunicado atualizado." : "Comunicado publicado.");
      await carregar();
    } catch(e){ showBanner("error", e.message || "Erro ao salvar."); }
    finally{setSaving(false);}
  };

  const handleDelete = async () => {
    setDeleting(true);
    try {
      await comunicadosService.deletar(deleteTarget.id);
      setShowDelete(false); setDeleteTarget(null);
      if(selected?.id===deleteTarget.id) setSelected(null);
      showBanner("success", "Comunicado excluído.");
      await carregar();
    } catch(e){ showBanner("error", e.message || "Erro ao excluir."); }
    finally{setDeleting(false);}
  };

  const condoNome = condominios.find(c=>String(c.id)===String(idCondo))?.nmFantasia||"";

  // Carrega estatísticas quando seleciona um comunicado
  useEffect(()=>{
    if (!selected?.id) { setEstatisticas(null); return; }
    comunicadosService.estatisticas(selected.id)
      .then(r => setEstatisticas(r.data || null))
      .catch(() => setEstatisticas(null));
  }, [selected?.id]);

  const handleReenviarNaoLidos = (c) => {
    if (!c?.id) return;
    setConfirmReenvio(c);
  };

  const confirmarReenvio = async () => {
    const c = confirmReenvio;
    if (!c?.id) { setConfirmReenvio(null); return; }
    setReenviando(true);
    try {
      const r = await comunicadosService.reenviar(c.id);
      showBanner("success", r.message || "Reenvio realizado.");
    } catch(e) { showBanner("error", e?.message || "Erro ao reenviar."); }
    setReenviando(false);
    setConfirmReenvio(null);
  };

  return (
    <div>
      <div className="page-header">
        <div>
          <h1 className="page-title"><i className="bi bi-megaphone me-2" style={{color:"var(--primary)",fontSize:22}}/>Comunicados</h1>
          <p className="page-subtitle">Publique avisos e comunicados para os condôminos</p>
        </div>
        <div className="d-flex gap-2 align-items-center flex-wrap">
          
          <button className="btn btn-primary" onClick={()=>abrirModal()} disabled={!idCondo}>
            <i className="bi bi-plus-lg"/> Novo Comunicado
          </button>
        </div>
      </div>

      {banner && (
        <Banner tipo={banner.tipo} onClose={()=>setBanner(null)}>
          {banner.msg}
        </Banner>
      )}

      {/* Alerta de novo push */}
      {novos.length>0&&(
        <div style={{background:"var(--bg-success-soft)",border:"1px solid #BBF7D0",borderRadius:8,padding:"10px 16px",marginBottom:16,display:"flex",justifyContent:"space-between",alignItems:"center",fontSize:13}}>
          <span style={{color:"#166534",fontWeight:600}}>
            <i className="bi bi-bell-fill me-2"/>
            {novos.length} novo(s) comunicado(s) recebido(s) via push
          </span>
          <button style={{background:"none",border:"none",color:"#166534",cursor:"pointer",fontSize:12,fontWeight:600}}
            onClick={()=>setNovos([])}>Dispensar</button>
        </div>
      )}

      <div style={{display:"flex",gap:16,alignItems:"flex-start"}}>
        {/* Lista */}
        <div style={{flex:1,minWidth:0}}>
          <div className="card">
            {/* Filtros */}
            <div style={{padding:"10px 16px",borderBottom:"1px solid var(--gray-100)",display:"flex",gap:8,flexWrap:"wrap",alignItems:"center"}}>
              <select className="form-select form-select-sm" style={{width:"auto"}} value={filtros.categoria} onChange={e=>setF("categoria",e.target.value)}>
                <option value="">Todas as categorias</option>
                {Object.keys(CATEGORIA_ICON).map(k=><option key={k} value={k}>{k}</option>)}
              </select>
              <select className="form-select form-select-sm" style={{width:"auto"}} value={filtros.ativo} onChange={e=>setF("ativo",e.target.value)}>
                <option value="">Todos</option>
                <option value="1">Ativos</option>
                <option value="0">Inativos</option>
              </select>
              <button className="btn btn-outline-secondary btn-sm" onClick={carregar}><i className="bi bi-arrow-clockwise"/></button>
              <span style={{marginLeft:"auto",fontSize:12.5,color:"var(--gray-400)"}}>{pagination.total} comunicado(s)</span>
            </div>

            {/* Cards */}
            <div style={{padding:12}}>
              {loading?<div className="text-center py-4"><span className="spinner-border spinner-border-sm text-primary"/></div>
              :!idCondo?<div className="text-center py-5" style={{color:"var(--gray-400)"}}><i className="bi bi-buildings" style={{fontSize:32,display:"block",marginBottom:8}}/>Selecione um condomínio</div>
              :data.length===0?<div className="text-center py-5" style={{color:"var(--gray-400)"}}><i className="bi bi-megaphone" style={{fontSize:32,display:"block",marginBottom:8}}/>Nenhum comunicado</div>
              :data.map(c=>{
                const catColor = CATEGORIA_COLOR[c.categoria]||"#6B7280";
                const catIcon  = CATEGORIA_ICON[c.categoria]||"bi-bell-fill";
                const prStyle  = PRIORIDADE_STYLE[c.prioridade]||PRIORIDADE_STYLE.Normal;
                const isSelected = selected?.id===c.id;
                return (
                  <div key={c.id} onClick={()=>setSelected(isSelected?null:c)}
                    style={{background:isSelected?"#EFF6FF":"#fff",border:`1px solid ${isSelected?"#BFDBFE":"var(--gray-200)"}`,
                      borderRadius:10,padding:"12px 14px",marginBottom:8,cursor:"pointer",
                      borderLeft:`4px solid ${catColor}`,transition:"all .15s"}}>
                    <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:8}}>
                      <div style={{display:"flex",gap:10,alignItems:"flex-start",flex:1,minWidth:0}}>
                        <div style={{width:36,height:36,borderRadius:8,background:catColor+"20",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                          <i className={`bi ${catIcon}`} style={{color:catColor,fontSize:17}}/>
                        </div>
                        <div style={{flex:1,minWidth:0}}>
                          <div style={{fontWeight:700,fontSize:13.5,color:"var(--gray-800)",marginBottom:3}}>{c.titulo}</div>
                          <div style={{fontSize:12.5,color:"var(--gray-500)",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{c.conteudo}</div>
                          <div style={{display:"flex",gap:6,marginTop:6,flexWrap:"wrap",alignItems:"center"}}>
                            <span style={{background:catColor+"15",color:catColor,padding:"1px 8px",borderRadius:10,fontSize:11,fontWeight:600}}>{c.categoria}</span>
                            <span style={{...prStyle,padding:"1px 8px",borderRadius:10,fontSize:11,fontWeight:600}}>{c.prioridade}</span>
                            <span style={{background:"var(--gray-100)",color:"var(--gray-500)",padding:"1px 8px",borderRadius:10,fontSize:11}}>{DEST_LABEL[c.destinatario]||c.destinatario}</span>
                            <span style={{fontSize:11,color:"var(--gray-400)",marginLeft:"auto"}}>{fmtDt(c.dtPublicacao)}</span>
                          </div>
                        </div>
                      </div>
                      <div style={{display:"flex",gap:4,flexShrink:0}}>
                        <span style={{background:"var(--bg-highlight)",color:"var(--primary)",padding:"2px 8px",borderRadius:10,fontSize:11,fontWeight:600}}>
                          <i className="bi bi-eye me-1"/>{c.qtdLeituras}
                        </span>
                        <button className="btn btn-outline-secondary btn-sm btn-icon" onClick={e=>{e.stopPropagation();abrirModal(c);}}><i className="bi bi-pencil"/></button>
                        <button className="btn btn-outline-danger btn-sm btn-icon" onClick={e=>{e.stopPropagation();setDeleteTarget(c);setShowDelete(true);}} disabled={!canEdit}><i className="bi bi-trash3"/></button>
                      </div>
                    </div>

                    {/* Detalhe expandido */}
                    {isSelected&&(
                      <div style={{marginTop:12,paddingTop:12,borderTop:"1px solid var(--gray-100)"}} onClick={e=>e.stopPropagation()}>
                        <div style={{fontSize:13,color:"var(--gray-700)",whiteSpace:"pre-wrap",lineHeight:1.6}}>{c.conteudo}</div>
                        {c.dtExpiracao&&<div style={{fontSize:11.5,color:"#C2410C",marginTop:8}}><i className="bi bi-clock me-1"/>Expira em: {fmtDt(c.dtExpiracao)}</div>}
                        <div style={{display:"flex",gap:8,marginTop:10,flexWrap:"wrap"}}>
                          {c.blocoDestino&&<span style={{fontSize:12,background:"#FFF7ED",color:"#C2410C",padding:"2px 10px",borderRadius:10}}>Bloco: {c.blocoDestino}</span>}
                          <span style={{fontSize:12,background:"var(--gray-100)",color:"var(--gray-500)",padding:"2px 10px",borderRadius:10}}>Criado por: {c.criadoPor}</span>
                          <span style={{fontSize:12,background:c.ativo?"#DCFCE7":"#FEE2E2",color:c.ativo?"#166534":"#991B1B",padding:"2px 10px",borderRadius:10,fontWeight:600}}>{c.ativo?"●  Ativo":"○  Inativo"}</span>
                        </div>

                        {/* Estatísticas de leitura */}
                        {estatisticas && (
                          <div style={{marginTop:14,padding:12,background:"var(--bg-surface-alt)",borderRadius:8,border:"1px solid var(--border-color)"}}>
                            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8}}>
                              <div style={{fontSize:12,fontWeight:700,color:"var(--gray-700)"}}>
                                <i className="bi bi-bar-chart me-1"/>Estatísticas de leitura
                              </div>
                              <div style={{fontSize:18,fontWeight:800,color:"var(--primary)"}}>
                                {estatisticas.pctLeitura}%
                              </div>
                            </div>
                            <div style={{display:"flex",height:8,borderRadius:99,overflow:"hidden",background:"#E2E8F0"}}>
                              <div style={{flex:estatisticas.qtdLeituras,background:"#22C55E"}}/>
                              <div style={{flex:estatisticas.naoLidos,background:"#94A3B8"}}/>
                            </div>
                            <div style={{display:"flex",justifyContent:"space-between",marginTop:6,fontSize:11.5,color:"var(--gray-500)"}}>
                              <span><strong style={{color:"#166534"}}>{estatisticas.qtdLeituras}</strong> leu(ram)</span>
                              <span><strong style={{color:"var(--gray-600)"}}>{estatisticas.naoLidos}</strong> não leu(ram) ainda</span>
                              <span>Total destinatários: <strong>{estatisticas.totalDestinatarios}</strong></span>
                            </div>
                            {estatisticas.naoLidos > 0 && c.ativo && (
                              <button className="btn btn-outline-primary btn-sm w-100 mt-2"
                                disabled={reenviando} onClick={()=>handleReenviarNaoLidos(c)}>
                                {reenviando
                                  ? <><span className="spinner-border spinner-border-sm me-2"/>Reenviando...</>
                                  : <><i className="bi bi-send-arrow-up me-1"/>Reenviar para os {estatisticas.naoLidos} que não leram</>}
                              </button>
                            )}
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>

            {/* Paginação */}
            {pagination.totalPages>1&&(
              <div className="pagination-wrapper">
                <span className="pagination-info">{pagination.total} registros</span>
                <nav><ul className="pagination pagination-sm mb-0">
                  <li className={`page-item ${filtros.page===1?"disabled":""}`}><button className="page-link" onClick={()=>setF("page",filtros.page-1)}><i className="bi bi-chevron-left"/></button></li>
                  {Array.from({length:pagination.totalPages},(_,i)=>(<li key={i+1} className={`page-item ${filtros.page===i+1?"active":""}`}><button className="page-link" onClick={()=>setF("page",i+1)}>{i+1}</button></li>))}
                  <li className={`page-item ${filtros.page===pagination.totalPages?"disabled":""}`}><button className="page-link" onClick={()=>setF("page",filtros.page+1)}><i className="bi bi-chevron-right"/></button></li>
                </ul></nav>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* ── MODAL NOVO/EDITAR COMUNICADO ── */}
      {showModal&&(
        <div className="modal fade show d-block" style={{background:"rgba(0,0,0,.55)"}} tabIndex="-1">
          <div className="modal-dialog modal-lg modal-dialog-scrollable">
            <div className="modal-content">
              <div className="modal-header">
                <div className="d-flex align-items-center gap-3">
                  <div style={{width:38,height:38,background:"rgba(255,255,255,.15)",borderRadius:8,display:"flex",alignItems:"center",justifyContent:"center"}}>
                    <i className="bi bi-megaphone" style={{fontSize:18,color:"#fff"}}/>
                  </div>
                  <div>
                    <h5 className="modal-title mb-0">{editData?"Editar Comunicado":"Novo Comunicado"}</h5>
                    <small style={{color:"rgba(255,255,255,.6)",fontSize:12}}>{condoNome}</small>
                  </div>
                </div>
                <button className="btn-close btn-close-white" onClick={()=>setShowModal(false)}/>
              </div>

              <div className="modal-body">
                <div className="form-section">
                  <div className="form-section-title"><i className="bi bi-card-heading"/> Conteúdo</div>
                  <div className="row g-3">
                    <div className="col-12">
                      <label className="form-label">Título <span className="required-mark">*</span></label>
                      <input className={`form-control ${errors.titulo?"is-invalid":""}`}
                        value={form.titulo} onChange={e=>setFm("titulo",e.target.value)}
                        placeholder="Título do comunicado"/>
                      {errors.titulo&&<div className="invalid-feedback">{errors.titulo}</div>}
                    </div>
                    <div className="col-12">
                      <label className="form-label">Conteúdo <span className="required-mark">*</span></label>
                      <textarea className={`form-control ${errors.conteudo?"is-invalid":""}`} rows={5}
                        value={form.conteudo} onChange={e=>setFm("conteudo",e.target.value)}
                        placeholder="Texto completo do comunicado..."/>
                      {errors.conteudo&&<div className="invalid-feedback">{errors.conteudo}</div>}
                    </div>
                  </div>
                </div>

                <div className="form-section">
                  <div className="form-section-title"><i className="bi bi-tags"/> Classificação</div>
                  <div className="row g-3">
                    <div className="col-md-4">
                      <label className="form-label">Categoria</label>
                      <select className="form-select" value={form.categoria} onChange={e=>setFm("categoria",e.target.value)}>
                        {Object.keys(CATEGORIA_ICON).map(k=><option key={k} value={k}>{k}</option>)}
                      </select>
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">Prioridade</label>
                      <select className="form-select" value={form.prioridade} onChange={e=>setFm("prioridade",e.target.value)}>
                        <option value="Normal">Normal</option>
                        <option value="Importante">Importante</option>
                        <option value="Urgente">Urgente</option>
                      </select>
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">Data de Expiração</label>
                      <input
                        type="datetime-local"
                        className={`form-control ${errors.dtExpiracao ? "is-invalid" : ""}`}
                        value={form.dtExpiracao}
                        onChange={e=>setFm("dtExpiracao",e.target.value)}
                      />
                      {errors.dtExpiracao
                        ? <div className="invalid-feedback">{errors.dtExpiracao}</div>
                        : <small style={{fontSize:11,color:"var(--gray-400)"}}>Vazio = sem expiração</small>}
                    </div>
                  </div>
                </div>

                <div className="form-section">
                  <div className="form-section-title"><i className="bi bi-people"/> Destinatários</div>
                  <div className="row g-3">
                    <div className="col-md-4">
                      <label className="form-label">Enviar para</label>
                      <select className="form-select" value={form.destinatario} onChange={e=>setFm("destinatario",e.target.value)}>
                        {Object.entries(DEST_LABEL).map(([v,l])=><option key={v} value={v}>{l}</option>)}
                      </select>
                    </div>
                    {form.destinatario==="PorBloco"&&(
                      <div className="col-md-4">
                        <label className="form-label">Bloco <span className="required-mark">*</span></label>
                        <input className="form-control" value={form.blocoDestino} onChange={e=>setFm("blocoDestino",e.target.value)}
                          placeholder="Ex: A, B, 1..."/>
                        <small style={{fontSize:11,color:"var(--gray-400)"}}>Todos do bloco informado receberão</small>
                      </div>
                    )}
                    {form.destinatario==="PorUnidade"&&(
                      <>
                        <div className="col-md-3">
                          <label className="form-label">Filtrar por Condômino</label>
                          <select className="form-select" value={form.idCondomino||""}
                            onChange={e=>{setFm("idCondomino",e.target.value); setFm("idUnidadeDestino","");}}>
                            <option value="">— Todos os condôminos —</option>
                            {condominos.map(c=>(
                              <option key={c.id} value={c.id}>{c.nmCompleto}</option>
                            ))}
                          </select>
                        </div>
                        <div className="col-md-4">
                          <label className="form-label">Unidade Específica <span className="required-mark">*</span></label>
                          <select className="form-select" value={form.idUnidadeDestino} onChange={e=>setFm("idUnidadeDestino",e.target.value)}>
                            <option value="">— Selecione a unidade —</option>
                            {(form.idCondomino
                              ? unidades.filter(u=>String(u.idCondomino)===String(form.idCondomino)||String(u.idCondomino2)===String(form.idCondomino))
                              : unidades
                            ).map(u=>(
                              <option key={u.id} value={u.id}>
                                {u.bloco?`Bl.${u.bloco} - `:""}{u.unidade}
                                {u.nmCondomino?` — ${u.nmCondomino}`:""}
                              </option>
                            ))}
                          </select>
                          <small style={{fontSize:11,color:"var(--gray-400)"}}>Enviado apenas para o condômino desta unidade</small>
                        </div>
                      </>
                    )}
                    {form.destinatario==="Proprietarios"&&(
                      <div className="col-md-7">
                        <label className="form-label">Proprietários</label>
                        <div style={{background:"var(--bg-highlight)",border:"1px solid #BFDBFE",borderRadius:8,padding:"10px 14px",fontSize:13}}>
                          <i className="bi bi-people-fill me-2" style={{color:"var(--primary)"}}/>
                          <strong style={{color:"var(--primary)"}}>Todos os Proprietários</strong> com vínculo ativo receberão este comunicado.
                          <div style={{fontSize:11.5,color:"var(--gray-500)",marginTop:4}}>
                            Total estimado: {unidades.filter(u=>u.nmCondomino).length} unidade(s) com proprietário ativo
                          </div>
                        </div>
                      </div>
                    )}
                    {form.destinatario==="Inquilinos"&&(
                      <div className="col-md-7">
                        <label className="form-label">Inquilinos</label>
                        <div style={{background:"#FFF7ED",border:"1px solid #FED7AA",borderRadius:8,padding:"10px 14px",fontSize:13}}>
                          <i className="bi bi-person-fill me-2" style={{color:"#C2410C"}}/>
                          <strong style={{color:"#C2410C"}}>Todos os Inquilinos</strong> com vínculo ativo receberão este comunicado.
                          <div style={{fontSize:11.5,color:"var(--gray-500)",marginTop:4}}>
                            Total estimado: {unidades.filter(u=>u.nmInquilino).length} unidade(s) com inquilino ativo
                          </div>
                        </div>
                      </div>
                    )}
                    <div className="col-md-4">
                      <label className="form-label">Criado Por</label>
                      <input className="form-control" value={form.criadoPor} onChange={e=>setFm("criadoPor",e.target.value)}/>
                    </div>
                  </div>

                  {/* Anexos */}
                  <div style={{marginTop:12}}>
                    <label className="form-label"><i className="bi bi-paperclip me-1"/>Documentos Anexos</label>
                    <AnexosUpload
                      anexos={anexosForm}
                      onAdd={a => setAnexosForm(p=>[...p,a])}
                      onRemove={async key => {
                        // Para anexos já persistidos (têm id no banco), chama a API DELETE.
                        // Para anexos ainda no form (sem id), remove só do estado.
                        const alvo = anexosForm.find(x => (x.id ?? null) === key);
                        if (alvo?.id && editData?.id) {
                          try { await comunicadosService.deletarAnexo(editData.id, alvo.id); } catch {}
                          setAnexosForm(p => p.filter(x => x.id !== alvo.id));
                        } else {
                          // 'key' aqui é o índice quando o anexo é local (sem id).
                          setAnexosForm(p => p.filter((_, i) => i !== key));
                        }
                      }}
                      onDownload={a => {
                        if (!a.id || !editData?.id) return;
                        // Abre rota de download em nova aba (já autenticada por cookie/JWT no api.js).
                        comunicadosService.downloadAnexo(editData.id, a.id)
                          .then(r => {
                            const link = document.createElement("a");
                            link.href = `data:${a.tpArquivo||"application/octet-stream"};base64,${r?.data?.base64||""}`;
                            link.download = a.nmArquivo;
                            link.click();
                          })
                          .catch(()=>{});
                      }}
                      label="Anexar Documento ao Comunicado"
                      accept=".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png,.txt"
                      maxSizeMB={10}/>
                  </div>

              {/* Preview destinatários */}
                  <div style={{marginTop:12,background:"var(--bg-success-soft)",borderRadius:8,padding:"10px 14px",fontSize:12.5,color:"#166534",display:"flex",alignItems:"center",gap:8}}>
                    <i className="bi bi-send-fill"/>
                    <span>
                      {form.destinatario==="Todos"&&"Este comunicado será enviado para TODOS os condôminos"}
                      {form.destinatario==="PorBloco"&&`Enviado apenas para o Bloco: ${form.blocoDestino||"(informe o bloco)"}`}
                      {form.destinatario==="PorUnidade"&&"Enviado para uma unidade específica"}
                      {form.destinatario==="Proprietarios"&&"Enviado apenas para Proprietários"}
                      {form.destinatario==="Inquilinos"&&"Enviado apenas para Inquilinos"}
                    </span>
                    {form.prioridade==="Urgente"&&<span style={{marginLeft:"auto",background:"var(--bg-danger-soft)",color:"#991B1B",padding:"2px 10px",borderRadius:10,fontWeight:600}}>🔴 Push Urgente</span>}
                    {form.prioridade==="Importante"&&<span style={{marginLeft:"auto",background:"#FFF7ED",color:"#C2410C",padding:"2px 10px",borderRadius:10,fontWeight:600}}>🟠 Push Importante</span>}
                  </div>
                </div>
              </div>

              <div className="modal-footer d-flex justify-content-between">
                <div style={{fontSize:12,color:"var(--gray-400)"}}>
                  <i className="bi bi-lightning-fill me-1" style={{color:"#F59E0B"}}/>
                  Ao publicar, todos os usuários conectados receberão uma notificação em tempo real
                </div>
                <div className="d-flex gap-2">
                  <button className="btn btn-outline-secondary" onClick={()=>setShowModal(false)}><i className="bi bi-x-circle"/> Cancelar</button>
                  <button className="btn btn-primary" onClick={handleSave} disabled={saving || !canEdit}>
                    {saving?<><span className="spinner-border spinner-border-sm me-2"/>Publicando...</>
                    :<><i className="bi bi-send"/> {editData?"Salvar":"Publicar"}</>}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <DeleteModal show={showDelete} onClose={()=>setShowDelete(false)} onConfirm={handleDelete}
        itemName={deleteTarget?.titulo} loading={deleting}/>

      {confirmReenvio && (
        <ConfirmModal
          titulo="Reenviar comunicado"
          mensagem={
            <div>
              <p>Reenviar <strong>"{confirmReenvio.titulo}"</strong> para condôminos que ainda não leram?</p>
              <p style={{fontSize:12,color:"var(--gray-400)",marginBottom:0}}>
                Será disparado e-mail e/ou WhatsApp para todos os destinatários do comunicado que ainda não marcaram como lido.
              </p>
            </div>
          }
          textoOk="Reenviar"
          textoCancelar="Cancelar"
          carregando={reenviando}
          onConfirm={confirmarReenvio}
          onCancel={()=>!reenviando && setConfirmReenvio(null)}
        />
      )}
    </div>
  );
}
